export default "__VITE_ASSET__L0oGPIi7__"